// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__8dSlE","active":"Statics_active__qbj4p"};